import { render, staticRenderFns } from "./bStore_products.vue?vue&type=template&id=2867b066&scoped=true"
import script from "./bStore_products.vue?vue&type=script&lang=js"
export * from "./bStore_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867b066",
  null
  
)

export default component.exports